import { Checkbox, FormControl, FormControlLabel, Grid, InputLabel, makeStyles, MenuItem, Paper, Select, TextField, Theme, Typography } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import React, { useGlobal } from 'reactn';
import { NumberField } from '../../components/NumberField';
import { SectionSubTitle } from '../../components/SectionSubTitle';
import { SectionTitle } from '../../components/SectionTitle';
import { IGlobalState } from '../../states/GlobalState';
import { globalStyles } from '../../style/GlobalStyles';
import data from '../../json/tabelle.json';
import { ADD_COM_IRPEF_PercDataClass, DefaultInputProps } from '../../types/types';
import { regioni } from "../../utils/costanti";
import { API_elaboraIForfetari } from '../../utils/functions';

// const useStyles = makeStyles((theme: Theme) =>
//     createStyles({
//         formControl: {
//             margin: theme.spacing(1),
//             //minWidth: 320,
//         },
//         textField: {
//             marginLeft: theme.spacing(1),
//             marginRight: theme.spacing(1),
//             width: 200,
//         },
//         bottomControlLabel: {
//             verticalAlign: 'bottom',
//         },
//         select: {
//             width: "10rem",
//         },
//     }),
// );

export default function DatiCollaboratore2(props: DefaultInputProps) {
    const [global] = useGlobal<IGlobalState>();
    // const classes = useStyles();
    const gClasses = globalStyles();
    const action = "changeDatiCollaboratore2";
    const { state } = props;

    const handleChange = (e: any) => {
        let { name, value } = e.target;
        props.handleChange(action, name, value);
    };

    const handleChangeSelect = (e: any) => {
        handleChange(e);
        let { name, value } = e.target;
        API_elaboraIForfetari(props, global, name, value, action, true);
    };

    const handleChangeChecked = (e: any) => {
        let { name, checked } = e.target;
        props.handleChange(action, name, checked);
        API_elaboraIForfetari(props, global, name, checked, action, true);
    };

    const handleBlur = (e: any) => {
        //API_elaboraIForfetari(props, global);
    }

    const ADD_COM_IRPEF = data.ADD_COM_IRPEF as ADD_COM_IRPEF_PercDataClass;

    let error = state.datiCollaboratore2.nomeCognome2 === undefined || state.datiCollaboratore2.nomeCognome2 === "";
    return (
        <React.Fragment>
            {state.quotaCollab2 !== undefined && state.quotaCollab2 > 0 ?
                (
                    <Paper className={gClasses.mainPaper}>
                        <SectionTitle text="Dati collaboratore 2"></SectionTitle>
                        <TextField
                            required
                            error={error}
                            helperText={error ? "Campo obbligatorio" : ""}
                            onBlur={handleBlur}
                            id="nomeCognome2"
                            name="nomeCognome2"
                            label="Nome collaboratore"
                            value={state.datiCollaboratore2.nomeCognome2}
                            onChange={handleChange}
                            className={gClasses.textField}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            margin="normal"
                        />
                        <div>
                            <SectionSubTitle text="Redditi diversi da impresa/lav. Autonomo"></SectionSubTitle>
                            <NumberField
                                name="redditiDiversiDaImpresa_LavAutonomo_E123"
                                label="Pensione"
                                value={state.datiCollaboratore2.redditiDiversiDaImpresa_LavAutonomo_E123}
                                className={gClasses.textField}
                                onChange={handleChange} onBlur={handleBlur}
                            />
                            <NumberField
                                name="redditiDiversiDaImpresa_LavAutonomo_E124"
                                label="Lav. dipendente e assim."
                                value={state.datiCollaboratore2.redditiDiversiDaImpresa_LavAutonomo_E124}
                                className={gClasses.textField}
                                onChange={handleChange} onBlur={handleBlur}
                                tooltip="Redditi di lavoro dipendente e assimilati per i quali spetta la detrazione d'imposta per redditi di lavoro dipendente."
                            />
                            <NumberField
                                name="redditiDiversiDaImpresa_LavAutonomo_E125"
                                label="Assimilati lav. dipendente"
                                value={state.datiCollaboratore2.redditiDiversiDaImpresa_LavAutonomo_E125}
                                className={gClasses.textField}
                                onChange={handleChange} onBlur={handleBlur}
                                tooltip="Redditi assimilati al reddito di lavoro dipendente per i quali spetta la detrazione d'imposta per redditi di lavoro non dipendente."
                            />
                            <NumberField
                                name="redditiDiversiDaImpresa_LavAutonomo_E126"
                                label="Diversi lettere i) e l)"
                                value={state.datiCollaboratore2.redditiDiversiDaImpresa_LavAutonomo_E126}
                                className={gClasses.textField}
                                onChange={handleChange} onBlur={handleBlur}
                            />
                            <NumberField
                                name="redditiDiversiDaImpresa_LavAutonomo_E127"
                                label="Fabbricati locati"
                                value={state.datiCollaboratore2.redditiDiversiDaImpresa_LavAutonomo_E127}
                                className={gClasses.textField}
                                onChange={handleChange} onBlur={handleBlur}
                                tooltip="Redditi dei fabbricati locati diversi da quelli da assoggettare a cedolare secca."
                            />
                            <NumberField
                                name="redditiDiversiDaImpresa_LavAutonomo_E128"
                                label="Altri"
                                value={state.datiCollaboratore2.redditiDiversiDaImpresa_LavAutonomo_E128}
                                className={gClasses.textField}
                                onChange={handleChange} onBlur={handleBlur}
                                tooltip="Redditi di capitale, redditi diversi escluse lettere i) e l) e redditi dei terreni affittati o esenti da IMU."
                            />
                            <NumberField
                                name="redditiDiversiDaImpresa_LavAutonomo_E129"
                                label="Abitazione principale"
                                value={state.datiCollaboratore2.redditiDiversiDaImpresa_LavAutonomo_E129}
                                className={gClasses.textField}
                                onChange={handleChange} onBlur={handleBlur}
                            />
                            <NumberField
                                name="redditiDiversiDaImpresa_LavAutonomo_E131"
                                label="Redditi a cedolare secca"
                                value={state.datiCollaboratore2.redditiDiversiDaImpresa_LavAutonomo_E131}
                                className={gClasses.textField}
                                onChange={handleChange} onBlur={handleBlur}
                            />
                        </div>

                        <SectionSubTitle text="Altri dati personali"></SectionSubTitle>
                        <Typography variant="h6">Familiari a Carico</Typography>
                        <Grid container spacing={1}>
                            <Grid container item xs={12}>
                            <Grid item xs={4}>
                                <FormControlLabel className={gClasses.bottomControlLabel}
                                    labelPlacement="end"
                                    control={
                                        <Checkbox
                                            checked={state.datiCollaboratore2.altriDatiPersonali_H124}
                                            name='altriDatiPersonali_H124'
                                            id='altriDatiPersonali_H124'
                                            value={state.datiCollaboratore2.altriDatiPersonali_H124}
                                            inputProps={{ 'aria-label': 'primary checkbox' }}
                                            onChange={handleChangeChecked}
                                        />
                                    }
                                    label="Coniuge"
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <FormControl className={gClasses.formControl}>
                                    <InputLabel htmlFor="altriDatiPersonali_J124">Figli n.</InputLabel>
                                    <Select
                                        className={gClasses.selectIForf}
                                        value={state.datiCollaboratore2.altriDatiPersonali_J124}
                                        inputProps={{ name: 'altriDatiPersonali_J124', id: 'altriDatiPersonali_J124' }}
                                        onChange={handleChangeSelect}
                                    >
                                        <MenuItem value={0}>Non definito</MenuItem>
                                        <MenuItem value={1}>1</MenuItem>
                                        <MenuItem value={2}>2</MenuItem>
                                        <MenuItem value={3}>3</MenuItem>
                                        <MenuItem value={4}>4</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={4}>
                                <FormControl className={gClasses.formControl}>
                                    <InputLabel htmlFor="altriDatiPersonali_L124">%</InputLabel>
                                    <Select
                                        className={gClasses.select}
                                        value={state.datiCollaboratore2.altriDatiPersonali_L124}
                                        inputProps={{ name: 'altriDatiPersonali_L124', id: 'altriDatiPersonali_L124' }}
                                        onChange={handleChangeSelect}
                                    >
                                        <MenuItem value={0}>Non definito</MenuItem>
                                        <MenuItem value={50}>50%</MenuItem>
                                        <MenuItem value={100}>100%</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            </Grid>
                            <Grid container item xs={12}>
                            <Grid item xs={4}>
                                <NumberField
                                    name="altriDatiPersonali_L126"
                                    label="Oneri deducibili"
                                    value={state.datiCollaboratore2.altriDatiPersonali_L126}
                                    className={gClasses.textField}
                                    onChange={handleChange} onBlur={handleBlur}
                                    helperText="(diversi dai contributi)"
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <NumberField
                                    name="altriDatiPersonali_L127"
                                    label="Detrazioni per oneri"
                                    value={state.datiCollaboratore2.altriDatiPersonali_L127}
                                    className={gClasses.textField}
                                    onChange={handleChange} onBlur={handleBlur}
                                    helperText="ed altre detrazioni e crediti"
                                />
                            </Grid>
                            </Grid>
                            <Grid container item xs={12} spacing={1}>
                            <Grid item xs={4}>
                                <FormControl className={gClasses.formControl}>
                                    <InputLabel htmlFor="altriDatiPersonali_I129">Regione di residenza</InputLabel>
                                    <Select
                                        className={gClasses.selectIForf}
                                        value={state.datiCollaboratore2.altriDatiPersonali_I129}
                                        inputProps={{ name: 'altriDatiPersonali_I129', id: 'altriDatiPersonali_I129' }}
                                        onChange={handleChangeSelect}
                                    >
                                        <MenuItem value={0}>Non definito</MenuItem>
                                        {regioni.map(regione => (
                                            <MenuItem key={regione.codice} value={regione.codice}>{regione.descrizione}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={4}>
                                <FormControl className={gClasses.formControl}>
                                    <InputLabel htmlFor="altriDatiPersonali_M129">Add. Com. Irpef</InputLabel>
                                    <Select
                                        className={gClasses.select}
                                        value={state.datiCollaboratore2.altriDatiPersonali_M129}
                                        inputProps={{ name: 'altriDatiPersonali_M129', id: 'altriDatiPersonali_M129' }}
                                        onChange={handleChangeSelect}
                                    >
                                        <MenuItem value={ADD_COM_IRPEF.perc_1}>{ADD_COM_IRPEF.perc_1}%</MenuItem>
                                        <MenuItem value={ADD_COM_IRPEF.perc_2}>{ADD_COM_IRPEF.perc_2}%</MenuItem>
                                        <MenuItem value={ADD_COM_IRPEF.perc_3}>{ADD_COM_IRPEF.perc_3}%</MenuItem>
                                        <MenuItem value={ADD_COM_IRPEF.perc_4}>{ADD_COM_IRPEF.perc_4}%</MenuItem>
                                        <MenuItem value={ADD_COM_IRPEF.perc_5}>{ADD_COM_IRPEF.perc_5}%</MenuItem>
                                        <MenuItem value={ADD_COM_IRPEF.perc_6}>{ADD_COM_IRPEF.perc_6}%</MenuItem>
                                        <MenuItem value={ADD_COM_IRPEF.perc_7}>{ADD_COM_IRPEF.perc_7}%</MenuItem>
                                        <MenuItem value={ADD_COM_IRPEF.perc_8}>{ADD_COM_IRPEF.perc_8}%</MenuItem>
                                        <MenuItem value={ADD_COM_IRPEF.perc_9}>{ADD_COM_IRPEF.perc_9}%</MenuItem>
                                        <MenuItem value={ADD_COM_IRPEF.perc_10}>{ADD_COM_IRPEF.perc_10}%</MenuItem>
                                        <MenuItem value={ADD_COM_IRPEF.perc_11}>{ADD_COM_IRPEF.perc_11}%</MenuItem>
                                        <MenuItem value={ADD_COM_IRPEF.perc_12}>{ADD_COM_IRPEF.perc_12}%</MenuItem>
                                        <MenuItem value={ADD_COM_IRPEF.perc_13}>{ADD_COM_IRPEF.perc_13}%</MenuItem>
                                        <MenuItem value={ADD_COM_IRPEF.perc_14}>{ADD_COM_IRPEF.perc_14}%</MenuItem>
                                        <MenuItem value={ADD_COM_IRPEF.perc_15}>{ADD_COM_IRPEF.perc_15}%</MenuItem>
                                        <MenuItem value={ADD_COM_IRPEF.perc_16}>{ADD_COM_IRPEF.perc_16}%</MenuItem>
                                        <MenuItem value={ADD_COM_IRPEF.perc_17}>{ADD_COM_IRPEF.perc_17}%</MenuItem>
                                        <MenuItem value={ADD_COM_IRPEF.perc_18}>{ADD_COM_IRPEF.perc_18}%</MenuItem>
                                        <MenuItem value={ADD_COM_IRPEF.perc_19}>{ADD_COM_IRPEF.perc_19}%</MenuItem>
                                        <MenuItem value={ADD_COM_IRPEF.perc_20}>{ADD_COM_IRPEF.perc_20}%</MenuItem>
                                        <MenuItem value={ADD_COM_IRPEF.perc_21}>{ADD_COM_IRPEF.perc_21}%</MenuItem>
                                        <MenuItem value={ADD_COM_IRPEF.perc_22}>{ADD_COM_IRPEF.perc_22}%</MenuItem>
                                        <MenuItem value={ADD_COM_IRPEF.perc_23}>{ADD_COM_IRPEF.perc_23}%</MenuItem>
                                        <MenuItem value={ADD_COM_IRPEF.perc_24}>{ADD_COM_IRPEF.perc_24}%</MenuItem>
                                        <MenuItem value={ADD_COM_IRPEF.perc_25}>{ADD_COM_IRPEF.perc_25}%</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={4}>
                                <NumberField
                                    name="quotaReddito"
                                    label="Quota reddito analitico"
                                    value={state.datiCollaboratore2.altriDatiPersonali_J130}
                                    className={gClasses.textFieldReadOnly}
                                    readOnly={true}
                                />
                            </Grid>
                            </Grid>
                        </Grid>
                    </Paper>
                ) : <p></p>}
        </React.Fragment>
    );
}